import { createAction } from 'redux-actions'

const Actions = {
  SET_TOKEN: 'SET_TOKEN',
  START_INIT: 'START_INIT',
  FINISH_INIT: 'FINISH_INIT',
  SHOW_ALL_PROFILES: 'SHOW_ALL_PROFILES',
  HIDE_ALL_PROFILES: 'HIDE_ALL_PROFILES',
  SHOW_PROFILE: 'SHOW_PROFILE',
  HIDE_PROFILE: 'HIDE_PROFILE',
  RECEIVE_PROFILES: 'RECEIVE_PROFILES',
  RECEIVE_REPORTS: 'RECEIVE_REPORTS'
}

export default Actions

export const setToken = createAction(Actions.SET_TOKEN)
export const startInit = createAction(Actions.START_INIT)
export const finishInit = createAction(Actions.FINISH_INIT)
export const showAllProfiles = createAction(Actions.SHOW_ALL_PROFILES)
export const hideAllProfiles = createAction(Actions.HIDE_ALL_PROFILES)
export const showProfile = createAction(Actions.SHOW_PROFILE)
export const hideProfile = createAction(Actions.HIDE_PROFILE)
export const receiveProfiles = createAction(Actions.RECEIVE_PROFILES)
export const receiveReports = createAction(Actions.RECEIVE_REPORTS)
